var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('MenuTopTemplate',{attrs:{"titulo":'PAGAMENTO PIX',"icone":require('../assets/icons/pix.png'),"onPressedClose":_vm.fechar}}),_c('DeliverySucessoView')],1)}
var staticRenderFns = []

export { render, staticRenderFns }